import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  min-height: 100vh;
  padding-top: 120px;
  @media (min-width: 768px) {
    padding-top: 155px;
  }
`;

export const ContainerMenu = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  align-content: center;
  width: 80%;
  height: 80%;

  border: 5px solid #152044;

  margin-bottom: 20px;
  @media (max-width: 768px) {
    border: none;
  }
`;

export const LoadingGif = styled.img`
  width: 80vw;
  height: 80vh;
  text-align: center;
`;
